const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/coin-aid-comment/search', { params })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/coin-aid-comment/create', params)
  },
  groupCreate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/coin-aid-comment/group-create', params)
  },
  list ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/coin-aid-comment/list', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
